import { initOnRamp } from '@coinbase/cbpay-js';

const appId = '21db2a6f-1015-4943-88d8-771f627a2b80';
let onrampInstance;

export default (address, defaultExperience) => {
  if (onrampInstance) onrampInstance.destroy();

  initOnRamp({
    appId,
    target: '#cbpay-container',
    widgetParameters: {
      destinationWallets: [{
        address,
        defaultExperience,
        assets: ['ETH', 'USDC'],
        supportedNetworks: ['base'],
      }],
    },
    onSuccess: () => { /* handle navigation when user successfully completes the flow */ },
    onExit: () => { /* handle navigation from dismiss / exit events due to errors */ },
    onEvent: (event) => { /* event stream */ },
    experienceLoggedIn: 'embedded',
    experienceLoggedOut: 'popup',
  }, (error, instance) => {
    if (error) console.error(error);
    if (instance) {
      onrampInstance = instance;
      instance.open();
    }
  });
};